document.addEventListener('DOMContentLoaded', function () {
  const openDetailsButton = document.getElementById('openDetails');
  const openSizeGuideButton = document.getElementById('openSizeGuide');
  const openPaymentShippingButton = document.getElementById('openPaymentShipping');
  const offCanvasMenu = document.getElementById('offCanvasMenu');
  const closeMenuButton = document.getElementById('closeMenu');
  const overlay = document.getElementById('custom-overlay');
  const menuContent = document.getElementById('menuContent');

  function openMenu(content) {
    menuContent.innerHTML = content;
    offCanvasMenu.classList.add('open');
    overlay.classList.add('active');
    document.body.style.overflow = 'hidden'; // Prevent scrolling
  }

  function closeMenu() {
    offCanvasMenu.classList.remove('open');
    overlay.classList.remove('active');
    menuContent.innerHTML = '';
    document.body.style.overflow = ''; // Restore scrolling
  }

  function convertRichTextToHTML(richTextData) {
    if (!richTextData || !richTextData.children) return '';

    return richTextData.children.map(node => {
      if (node.type === 'paragraph') {
        const content = node.children.map(child => {
          if (child.type === 'text') {
            let text = child.value;
            if (child.bold) text = `<strong>${text}</strong>`;
            return text;
          }
          return '';
        }).join('');
        return `<p>${content}</p>`;
      }
      return '';
    }).join('');
  }

  openDetailsButton?.addEventListener('click', function () {
    let productInfo = 'No information found';

    // Try to get product info from the data attribute
    const productMetaElement = document.getElementById('ProductMeta');
    if (productMetaElement) {
      const dataProductInfo = productMetaElement.getAttribute('data-product-information');
      if (dataProductInfo && dataProductInfo.trim() !== '') {
        try {
          const richTextData = JSON.parse(dataProductInfo);
          productInfo = convertRichTextToHTML(richTextData);
        } catch (e) {
          // If JSON parsing fails, use the raw data
          productInfo = dataProductInfo;
        }
      }
    }

    openMenu(`<h2>Product Details</h2><div>${productInfo}</div>`);
  });
  
openSizeGuideButton?.addEventListener('click', function () {
  openMenu(`
    <h2>Size Guide</h2>

    <table class="size-guide">
      <tbody>
        <tr><th>Finger circumference in mm</th><th>∅ ring in mm</th></tr>
        <tr><td>44</td><td>14.10</td></tr>
        <tr><td>45</td><td>14.35</td></tr>
        <tr><td>46</td><td>14.65</td></tr>
        <tr><td>47</td><td>15.04</td></tr>
        <tr><td>48</td><td>15.20</td></tr>
        <tr><td>49</td><td>15.40</td></tr>
        <tr><td>50</td><td>15.80</td></tr>
        <tr><td>51</td><td>16.10</td></tr>
        <tr><td>52</td><td>16.51</td></tr>
        <tr><td>53</td><td>16.92</td></tr>
        <tr><td>54</td><td>17.15</td></tr>
        <tr><td>55</td><td>17.35</td></tr>
        <tr><td>56</td><td>17.75</td></tr>
        <tr><td>57</td><td>18.19</td></tr>
        <tr><td>58</td><td>18.61</td></tr>
        <tr><td>59</td><td>18.65</td></tr>
        <tr><td>60</td><td>19.10</td></tr>
      </tbody>
    </table>

    <h3>How to measure:</h3>
    <ol>
      <li>Wrap a ribbon around the base of your finger. To make sure the ring will fit comfortably, we suggest also measuring your knuckle.</li>
      <li>Use a pen, mark the point where the ribbon crosses.</li>
      <li>Measure the distance with a ruler in mm, this will be your finger’s circumference.</li>
      <li>Choose the closest measurement from the table above to identify your ring size.</li>
    </ol>

    <hr>
    <h3>Necklace Sizing</h3>
    <p>Our necklace sizes are defined within the product information. If you desire a different dimension, please complete the <a href="https://izabo.eu/en-eu/pages/custom-orders" target="_blank">custom order form</a>, and we’ll get back to you as soon as possible.</p>

    <hr>
    <h3>Choker Sizing</h3>
    <p>Unless defined otherwise within the product information, IZABO uses general sizing ranging from small to large. We recommend selecting the same size you typically wear in clothing. Dimensions:</p>
    <ul>
      <li><strong>Small:</strong> 30cm — 35cm | 12″ — 14″</li>
      <li><strong>Medium:</strong> 36cm — 41cm | 14″ — 16″</li>
      <li><strong>Large:</strong> 42cm — 47cm | 16″ — 18″</li>
    </ul>
    <p>If you desire a different dimension, please complete the <a href="https://izabo.eu/en-eu/pages/custom-orders" target="_blank">custom order form</a>, and we’ll get back to you as soon as possible.</p>

    <hr>
    <h3>Bracelet Sizing</h3>
    <p>Unless defined otherwise within the product information, IZABO uses general sizing ranging from small to large. Dimensions:</p>
    <ul>
      <li><strong>Small:</strong> 15cm — 16cm | 5.9″ — 6.3″</li>
      <li><strong>Medium:</strong> 17cm — 18cm | 6.7″ — 7.1″</li>
      <li><strong>Large:</strong> 19cm — 20cm | 7.5″ — 7.9″</li>
    </ul>
    <p>If you desire a different dimension, please complete the <a href="https://izabo.eu/en-eu/pages/custom-orders" target="_blank">custom order form</a>, and we’ll get back to you as soon as possible.</p>
  `);
});

openPaymentShippingButton?.addEventListener('click', function () {
  openMenu(`
    <h2>Payment & Shipping</h2>

    <h3>Shipping Policy</h3>
    <p>Questions about shipping, delivery, or import duties? Reach out to us anytime via <a href="https://api.whatsapp.com/message/MQFCWH6ML7UGO1?autoload=1&amp;app_absent=0" target="_blank">WhatsApp</a> or email us at <a href="mailto:sales@izabo.eu">sales@izabo.eu</a> — we’re here to help.</p>

    <hr>
    <h3>Production & Delivery Timing</h3>
    <ul>
      <li><strong>In stock pieces:</strong> Shipped within 1–5 business days.</li>
      <li><strong>Custom orders:</strong> Can take up to 7 weeks, depending on complexity, availability, and sourcing of materials.</li>
    </ul>

    <hr>
    <h3>Why the Wait?</h3>
    <p>Each IZABO piece is handmade in our studio to ensure timeless quality and intentional craftsmanship. It takes time — but it’s always worth the wait.</p>

    <hr>
    <h3>Payment Methods Accepted</h3>
    <p>We accept American Express, Visa, Mastercard, and all major payment methods. If your preferred method isn’t listed, please get in touch at <a href="mailto:sales@izabo.eu">sales@izabo.eu</a> or message us on <a href="https://api.whatsapp.com/message/MQFCWH6ML7UGO1?autoload=1&amp;app_absent=0" target="_blank">WhatsApp</a> — we’ll be happy to assist you.</p>
  `);
});



  closeMenuButton?.addEventListener('click', closeMenu);

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) {
      closeMenu();
    }
  });
});
